import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

export const SIMPLE_FADE_ANIMATION = trigger('simpleFadeAnimation', [
  transition(':enter', [style({ opacity: 0 }), animate('300ms', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('300ms', style({ opacity: 0 }))]),
]);

export const FADE_ANIMATION = trigger('fadeAnimation', [
  transition('* => *', [
    // each time the binding value changes
    query(':leave', [stagger(50, [animate('0.1s', style({ opacity: 0 }))])], { optional: true }),
    query(':enter', [style({ opacity: 0 }), stagger(100, [animate('0.15s', style({ opacity: 1 }))])], {
      optional: true,
    }),
  ]),
]);

export const LIST_ANIMATION = trigger('listAnimation', [
  transition('* <=> *', [
    query(':enter', [style({ opacity: 0 }), stagger('60ms', animate('600ms ease-out', style({ opacity: 1 })))], {
      optional: true,
    }),
    query(':leave', animate('200ms', style({ opacity: 0 })), { optional: true }),
  ]),
]);
